module.exports = __webpack_public_path__ + "assets/img/q_primary.6897ae0f.svg";